function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHochbeetIconEigen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 552",
    cx: 18,
    cy: 18,
    r: 18,
    style: {
      fill: "#a75712"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2773",
    d: "M27 24.152H9v-7H7v9h22v-9h-2z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2489",
    transform: "translate(11 20.259)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h14v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2774",
    d: "M13.542 11.36a8.524 8.524 0 0 0 3.437 2.021v3.67h2v-4.7a8.593 8.593 0 0 0 3.57-2.064 8.771 8.771 0 0 0 2.2-4.129l.138-.724-.724.14a8.737 8.737 0 0 0-4.115 2.2 8.782 8.782 0 0 0-2.166 3.994 8.326 8.326 0 0 0-1.831-2.926 8.732 8.732 0 0 0-4.114-2.2l-.724-.139.138.724a8.784 8.784 0 0 0 2.195 4.129m7.211-2.871A7.488 7.488 0 0 1 23.526 6.8a7.509 7.509 0 0 1-1.686 2.785 7.481 7.481 0 0 1-2.77 1.688 7.536 7.536 0 0 1 1.683-2.784m-5.415 1.068a7.436 7.436 0 0 1 1.641 2.676v.092a7.466 7.466 0 0 1-2.728-1.671 7.544 7.544 0 0 1-1.683-2.785 7.5 7.5 0 0 1 2.77 1.688",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2490",
    transform: "translate(14.972 17.052)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h2v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2491",
    transform: "translate(10.972 17.052)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h2v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2492",
    transform: "translate(23.028 17.052)",
    style: {
      fill: "#f5f5f5"
    },
    d: "M0 0h2v2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2775",
    d: "M21.028 19.052v-2h-2.055v2h2.055z",
    style: {
      fill: "#f5f5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHochbeetIconEigen);
export default __webpack_public_path__ + "static/media/Hochbeet_Icon_Eigen.8e920e29135e712182c60bda6a42c7a2.svg";
export { ForwardRef as ReactComponent };